export const ru = {
    'cloud-name': 'ООО «Яндекс.Облако»',
    'label-item-privacy': 'Политика конфиденциальности',
    'label-item-terms': 'Условия использования',
    'login-button-label': 'Войти в Wiki'
};
